import React, { useEffect, useState } from 'react'
import {
  MessageBox,
  Link,
  MESSAGE_BOX_VARIANT_WARNING,
  MESSAGE_BOX_VARIANT_DANGER,
  MESSAGE_BOX_VARIANT_SUCCESS,
  Flex,
  SpacingVertical,
  SPACING_24
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

import { pageState } from 'Pages/QuickSend/recoil/state/state'
import { notifyOpener } from 'Helpers/notifyParent'
import {
  PECPLUS_STATUS_IN_PROGRESS_DESCR,
  PECPLUS_STATUS_ERROR_DESCR
} from 'Constants'
import {
  QUICKSEND_SEND_RESULT_ERROR,
  QUICKSEND_SEND_RESULT_FORBIDDEN
} from 'Api/beSendGoApi'
import { useParams } from 'react-router-dom'

const WarningMessages = () => {
  const intl = useIntl()
  const { id: idMessage } = useParams()

  const [
    {
      pecPlusStatus,
      messageErrors,
      sendResponse,
      verifyResponse,
      showVerifyResponse
    },
    setPageState
  ] = useRecoilState(pageState)

  const otherNotSent = sendResponse
    ? sendResponse.EmailBlacklist.concat(
        sendResponse.EmailEnqueueFailed,
        sendResponse.EmailNotSentDueGenerelError
      )
    : []
  const [showSuccess, setShowSuccess] = useState(false)

  const handleClickCheckup = () => {
    notifyOpener('redirectMainFrame', [
      `/console/messages_app_redirector.aspx?r=/messages/email/${idMessage}/checkup/summary`
    ])
  }

  const handleClickPecWarning = () => {
    notifyOpener('redirectMainFrame', [
      '/console/form_upd_nl.aspx?visualmode=1&tab=mittenti'
    ])
  }

  const handleCloseSuccess = () => {
    setShowSuccess(false)
  }

  const closeVerifyResponse = () => {
    setPageState(prev => ({
      ...prev,
      showVerifyResponse: false
    }))
  }

  useEffect(() => {
    if (sendResponse && sendResponse.EmailSent.length > 0) {
      setShowSuccess(true)
      setTimeout(() => setShowSuccess(false), 5000)
    }
  }, [sendResponse])

  useEffect(() => {
    if (verifyResponse === MESSAGE_BOX_VARIANT_SUCCESS) {
      setTimeout(
        () =>
          setPageState(prev => ({
            ...prev,
            showVerifyResponse: false
          })),
        5000
      )
    }
  }, [verifyResponse])

  if (
    !showSuccess &&
    !showVerifyResponse &&
    !messageErrors &&
    !pecPlusStatus &&
    !sendResponse
  ) {
    return null
  }

  return (
    <>
      {showVerifyResponse && (
        <MessageBox
          variant={verifyResponse}
          closeButton={verifyResponse === MESSAGE_BOX_VARIANT_SUCCESS}
          closeButtonCallback={
            verifyResponse === MESSAGE_BOX_VARIANT_SUCCESS
              ? closeVerifyResponse
              : undefined
          }
        >
          <p>
            {verifyResponse === MESSAGE_BOX_VARIANT_SUCCESS &&
              intl.formatMessage({ id: 'Load.Common.EmailSendMessage' })}
            {verifyResponse === MESSAGE_BOX_VARIANT_DANGER &&
              intl.formatMessage({ id: 'Load.Common.LoadingDataError' })}
          </p>
        </MessageBox>
      )}
      {messageErrors && (
        <MessageBox variant={MESSAGE_BOX_VARIANT_DANGER}>
          {intl.formatMessage(
            { id: 'Load.QuickSend.disableSendingNew' },
            {
              link: chunks => <Link onClick={handleClickCheckup}>{chunks}</Link>
            }
          )}
        </MessageBox>
      )}
      {pecPlusStatus === PECPLUS_STATUS_ERROR_DESCR && (
        <MessageBox variant={MESSAGE_BOX_VARIANT_DANGER}>
          {intl.formatMessage(
            { id: 'Load.Common.ConfigPecErrorNew' },
            {
              link: chunks => (
                <Link onClick={handleClickPecWarning}>{chunks}</Link>
              )
            }
          )}
        </MessageBox>
      )}
      {pecPlusStatus === PECPLUS_STATUS_IN_PROGRESS_DESCR && (
        <MessageBox variant={MESSAGE_BOX_VARIANT_WARNING}>
          {intl.formatMessage(
            { id: 'Load.PecPlus.WarinigConfingInProgressNew' },
            {
              link: chunks => (
                <Link onClick={handleClickPecWarning}>{chunks}</Link>
              )
            }
          )}
        </MessageBox>
      )}
      {showSuccess && (
        <MessageBox
          variant={MESSAGE_BOX_VARIANT_SUCCESS}
          closeButton
          closeButtonCallback={handleCloseSuccess}
        >
          <Flex>
            <p>
              {intl.formatMessage({ id: 'Load.StatusMessages.lblNoErrori' })}{' '}
              {sendResponse.EmailSent.join(', ')}
            </p>
          </Flex>
        </MessageBox>
      )}
      {sendResponse &&
        (sendResponse.Result === QUICKSEND_SEND_RESULT_ERROR ||
          sendResponse.Result === QUICKSEND_SEND_RESULT_FORBIDDEN) && (
          <>
            <MessageBox variant={MESSAGE_BOX_VARIANT_WARNING}>
              <Flex>
                {sendResponse && sendResponse.EmailOptout.length > 0 && (
                  <>
                    <Flex>
                      <p>
                        {intl.formatMessage({
                          id: 'Load.StatusMessages.lblErrore3'
                        })}{' '}
                        {sendResponse.EmailOptout.join(', ')}
                      </p>
                    </Flex>
                  </>
                )}
                {sendResponse.EmailNotSent.length > 0 &&
                  sendResponse.EmailOptout.length === 0 &&
                  sendResponse.EmailNotSentDueRecipientSuspended.length ===
                    0 && (
                    <>
                      <Flex>
                        <p>
                          {intl.formatMessage({
                            id: 'Load.StatusMessages.lblErrore4'
                          })}{' '}
                          {otherNotSent.join(', ')}
                        </p>
                      </Flex>
                    </>
                  )}
                {sendResponse.EmailNotSentDueRecipientSuspended &&
                  sendResponse.EmailNotSentDueRecipientSuspended.length > 0 && (
                    <>
                      <Flex>
                        <p>
                          {intl.formatMessage({
                            id: 'Load.StatusMessages.lblErrore6'
                          })}{' '}
                          {sendResponse.EmailNotSentDueRecipientSuspended.join(
                            ', '
                          )}
                        </p>
                      </Flex>
                    </>
                  )}
                {sendResponse.Result === QUICKSEND_SEND_RESULT_FORBIDDEN && (
                  <p>
                    {intl.formatMessage({
                      id: 'Load.StatusMessages.lblErrore5'
                    })}
                  </p>
                )}
              </Flex>
            </MessageBox>
          </>
        )}
      <SpacingVertical variant={SPACING_24} />
    </>
  )
}

export default WarningMessages
